import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CustomLoading from "../../components/CustomLoading";
import { useDispatch, useSelector } from "react-redux";
import { selectBranchId, setActiveTab } from "../../redux/features/authSlice";
import { useLocation } from "react-router-dom";
import { useGetRiderListQuery } from "../../redux/api/riderApi/riderApi";

const RiderList = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [filterText, setFilterText] = useState("");
    const branch_id = useSelector(selectBranchId);
    const { data: riderList, isLoading: riderLoading } =
        useGetRiderListQuery(branch_id);

    const columns = [
        {
            name: 'ID',
            selector: row => row?.id,
            sortable: true,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Contact Number',
            selector: row => row.contact_number,
            sortable: true,
        },
        {
            name: 'Address',
            selector: row => row?.address,
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => (
                <div className={`py-1 w-20 text-center rounded ${row.isActive ? "bg-success/10 text-success" : "bg-attention/10 text-attention"}`}>
                    {row.isActive ? "Active" : "Inactive"}
                </div>
            ),
            sortable: true,
        },
    ];

    const filteredMerchant = riderList?.filter(
        item => item.name && item.name.toLowerCase().includes(filterText.toLowerCase()),
    )?.reverse();

    useEffect(() => {
        if (pathname === "/rider-list") {
            dispatch(setActiveTab("Rider List"));
        }
    }, [dispatch, pathname]);
    return (
        <div className="w-full flex flex-col gap-10">
            <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex gap-5">
                <div className="flex flex-col justify-between w-full">
                    <div className="flex flex-col sm:flex-row gap-4 justify-between sm:items-center mb-5 sm:mb-0">
                        <div className="text-2xl font-bold text-text_1 mb-5 md:mb-0">Rider List</div>
                    </div>
                    <div className="flex flex-col md:flex-row gap-4 items-center">
                        <div className="flex flex-row gap-4 items-center w-full">
                            <input
                                type="text"
                                className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                                placeholder={`Search by rider name`}
                                onChange={(e) => setFilterText(e.target.value)}
                                value={filterText}
                            />
                            <button
                                disabled={!filterText}
                                onClick={() => {
                                    setFilterText("")
                                }}
                                className={`py-2 w-24 text-center border border-warning text-warning rounded bg-warning/10 flex items-center justify-center ${!filterText ? "" : "cursor-pointer transition-all hover:bg-warning hover:animate-pulse hover:text-white"}`}
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="h-40 hidden lg:flex">
                    <img
                        src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                        alt="self drive"
                        className="h-full w-full"
                    />
                </div>
            </div>
            <div className="overflow-x-auto bg-white shadow-lg rounded-lg p-2">
                <DataTable
                    columns={columns}
                    data={filteredMerchant}
                    pagination
                    persistTableHead
                    highlightOnHover
                />
            </div>
            {(riderLoading) && <CustomLoading />}
        </div>
    );
};

export default RiderList;
